export default __webpack_public_path__ + "b94310a0ed356e2971f1803de7901456.svg";